import React from "react";
import "./home.css";



const itemCardExternal = ({ name, title, image, route, fadeside }) => {
    if (fadeside == 1)
        return (
            <a href={route} target="_blank" className="item-menu col-6" >
   
                    <img src={image} alt="Product" />
                    <h1>{name}</h1>
                    <h6>{title}</h6>
            
            </a>
        );
    else
        return (
            <a href={route} target="_blank" className="item-menu col-6" >

                    <img src={image} alt="Product" />
                    <h1>{name}</h1>
                    <h6>{title}</h6>
 
            </a>
        );
};

export default itemCardExternal;
